import { render } from "./CustomerSectionFinancial.vue?vue&type=template&id=8e8e23e2"
import script from "./CustomerSectionFinancial.vue?vue&type=script&lang=js"
export * from "./CustomerSectionFinancial.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__